import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, OnInit, Input, Output, ElementRef, ViewChild, Inject} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { MatDialogModule, DialogPosition } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';  // needed by ToasterService
import { Observable } from 'rxjs';
//import 'rxjs/add/operator/toPromise';
//import 'rxjs/add/operator/map';


import { LocalStorageService } from 'angular-2-local-storage';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Toast, ToasterModule, ToasterService, ToasterConfig, BodyOutputType } from 'angular2-toaster';


import { AirportWebService } from '../../airport-web-service/airport-web-service';
import { IncidentLocation } from '../../incident-location/incident-location';
import { IncidentSublocation } from '../../incident-sublocation/incident-sublocation';
import { IncidentType } from '../../incident-type/incident-type';
import { Incident } from '../../incident/incident';
import { Credentials } from '../../credentials/credentials';
import { BaseResult } from '../../base-result';
import { DesktopService } from '../../desktop-service/desktop-service';
import { RequestEmailDialogComponent } from '../../request-email-dialog/request-email-dialog.component';

@Component({
  selector: 'app-sms-page',
  templateUrl: './sms-page.component.html',
  styleUrls: ['./sms-page.component.css'],
  providers: [RequestEmailDialogComponent]
})
export class SmsPageComponent implements OnInit {

  locations: IncidentLocation[];
  sublocations: IncidentSublocation[];
  sublocationRequired: boolean = false;
  incidentTypes: IncidentType[] = new Array<IncidentType>();
  selectedLocation: IncidentLocation;

  @Input() incidentLocation: string;
  @Input() incidentSublocation: string;
  @Input() incidentDescription: string;
  @Input() incidentType: string;
  @Input() reportingEmail: string;
  @Input() incidentDate: Date;
  settings = {
        bigBanner: true,
        timePicker: true,
        format: 'MM-dd-yyyy hh:mm a',
        defaultOpen: false,
        closeOnSelect: true
    };


  @Output() thumbnailLocation: string = this.airportws.serverName + '/img/SingleTransparentPixel.png';
  pictureName: string = '';

  @Output() messageDate: string = ' not required';
  @Output() messageLocation: string = 'required';
  @Output() messageSublocation: string  = 'required';
  @Output() messageDescription: string = ' not required';
  @Output() messageIncidentType: string  = 'required';

  appPlatform: string;

  @ViewChild('photoPath') public photoPath: ElementRef;

  /*
   * Possible config parms
    limit?: number | null;
    tapToDismiss: boolean;
    showCloseButton: boolean | Object;
    closeHtml: string;
    newestOnTop: boolean;
    timeout: number | Object;
    typeClasses: Object;
    iconClasses: Object;
    bodyOutputType: BodyOutputType;
    bodyTemplate: string;
    defaultTypeClass: string;
    positionClass: string;
    titleClass: string;
    messageClass: string;
    animation: string;
    preventDuplicates: boolean;
    mouseoverTimerStop: boolean;
   */
  public toasterConfig: ToasterConfig = new ToasterConfig({
    positionClass: 'toast-top-center',
    tapToDismiss: true,
    newestOnTop: true,
    showCloseButton: false
  });

  constructor(
    private airportws: AirportWebService,
    private desktopService: DesktopService,
    private http: HttpClient,
    private storage: LocalStorageService,
    private device: DeviceDetectorService,
    private alertController: ToasterService,
    public dialog: MatDialog) { }




  ngOnInit() {
    this.incidentDate = new Date();
    this.getIncidentTypes();
    this.getLocations();

    this.messageLocation = '';
    this.messageDate = '';
    this.messageSublocation = '';
    this.messageIncidentType = '';
    this.messageDescription = '';
  }




  // loading form.....
  getIncidentTypes(): void {
    console.log('sms.getIncidentTypes()');

    const action = `${this.airportws.baseURL}/GetIncidentTypes`;

    this.http.post(action, null, { headers: { 'Content-Type': 'application/json' } } ).
      subscribe(
        success => {
          this.incidentTypes = (success as IncidentType[]);
        },
        error => {
          console.log('sms.getIncidentTypes() - ERROR getting incident types: ' + error);
        }
     );
  }


  getLocations(): void {
    console.log('sms.getLocations()');
    console.log(`${this.airportws.baseURL}`);

    const action = `${this.airportws.baseURL}/GetLocations`;
    console.log(`${action}`);

    this.http.post(action, null, { headers: { 'Content-Type': 'application/json' } } ).
      subscribe(
        success => {
          this.locations = (success as IncidentLocation[]);
        },
        error => {
          console.log('sms.getLocations() - ERROR getting locations: ' + error);
        }
     );
  }

  onSelectLocation(locationIn: string): void {
    console.log(`getLocations() ${locationIn}`);

    // reset any previous sublocation value
    this.incidentSublocation = null;

    // save the value and update our sublocation list
    if (locationIn == null || locationIn === '') {
      // this occurs during form reset
      this.selectedLocation = null;
    } else {
      this.selectedLocation = JSON.parse(locationIn);
      this.getSublocations(this.selectedLocation.id);
    }
  }

  getSublocations(parentId: number): void {
    console.log('sms.getSublocations()' + parentId);
    console.log(`${this.airportws.baseURL}`);

    const action = `${this.airportws.baseURL}/GetSublocations`;
    console.log(`${action}`);

    this.http.post(action, null, { headers: { 'Content-Type': 'application/json' } } ).
      subscribe(
        success => {
          this.sublocations = (success as IncidentSublocation[]);
          this.filterSublocations(parentId);
        },
        error => {
          console.log('sms.getSublocations() - ERROR getting sublocations: ' + error);
        }
     );
  }

  filterSublocations(parentId: number) {

    console.log('sms.filterSublocations(' + parentId + ')');
    if (parentId > 0) {
      this.sublocations = this.sublocations.filter( function(aSublocation) { return aSublocation.locationId === parentId; } );
    }

    // if we have sublocations to display, then this field becomes required, otherwise not required
    if (this.sublocations.length > 0) {
     this.sublocationRequired = true;
    } else {
      this.sublocationRequired = false;
    }
  }

  public getPictureFromDesktop(eventIn: Event): void {
    console.log('eventIn: ' + eventIn);
    this.desktopService.getPictureFromDesktop(this.desktopService, this, eventIn);
  }


  public validateForm(): void {
    console.log('validateForm()');

    if (this.validateFormValues() === false) {
       console.log(`validateFormValues returned false - not submitting form`);

       return;
    } else if (this.reportingEmail === undefined || this.reportingEmail === null || this.reportingEmail === '') {

      console.log('politely requesting they enter their email address');

      const politeRequestDialogRef = this.dialog.open(RequestEmailDialogComponent, {
        height: '300px',
        width: '400px',
        position: {
          top: '25px'
        }
      });

      politeRequestDialogRef.afterClosed().subscribe(
        result => {

          console.log(`Dialog result: ${result}`);

          if (result === true) {
            console.log('Not submitting form; user is going to enter email address');
          } else {
            console.log('Submitting form; user wants to remain anonymous');
            this.submitForm();
          }

        }
      );

    } else {
      console.log('validateForm about to call submitForm');
      console.log('reportingEmail: ' + this.reportingEmail);
      this.submitForm();
    }
  }

  private validateFormValues(): boolean {

    console.log(`validating form - test`);

    let rtVal = true;

    // reset any previous validation messages
    this.messageDate = '';
    this.messageLocation = '';
    this.messageSublocation = '';
    this.messageIncidentType = '';
    this.messageDescription = '';

    // validate
    console.log('validateFormValues() - incidentDate: ' + this.incidentDate);
    if (this.incidentDate === null || this.incidentDate === undefined) {
      this.messageDate = 'Required';
      rtVal = false;
    } else if (new Date(this.incidentDate).getMilliseconds() > Date.now()) {
      this.incidentDate = new Date();
    }

//    if(this.incidentLocation == null)
//    {
//      this.messageLocation = "Required";
//      rtVal = false;
//    }

//    if(this.sublocationRequired == true && this.incidentSublocation == null )
//    {
//      this.messageSublocation = "Required";
//      rtVal = false;
//    }

    if (this.incidentType == null) {
      this.messageIncidentType = 'Required';
      rtVal = false;
    }

    if (this.incidentDescription == null) {
      this.messageDescription = 'Required';
      rtVal = false;
    }

    console.log('validateFormValues returning: ' + rtVal);
    return rtVal;
  }


  // submitting form.....

  // send the incident report
  submitForm(): void {
    console.log(`submitting form`);

    const toast: Toast = {
        type: 'info',
        title: '',
        body: 'Submitting report.  Please wait...',
        showCloseButton: false,
        closeHtml: ''
    };

    const loader = this.alertController.pop( toast );
//    let loader = this.loadingController.create({ content: "Submitting report.  Please wait...", cssClass: "errorAlert" });
//    loader.present();

    const action = `${this.airportws.baseURL}/CWSubmitIncident`;

    const incidentReport: Incident = new Incident();
    incidentReport.loginCredentials = new Credentials();

    console.log('submitting report for date: ' + this.incidentDate);
    incidentReport.incidentDate = new Date(this.incidentDate).toISOString();

    incidentReport.incidentType = JSON.parse(this.incidentType) as IncidentType;


    console.log('this.incidentLocation: ' + this.incidentLocation);
    if (this.incidentLocation === null || this.incidentLocation === undefined || this.incidentLocation === '') {
      this.incidentLocation = '{ "id": 0, "sortOrder": 1, "name":  "Not submitted" }';
    }
    incidentReport.incidentLocation = JSON.parse(this.incidentLocation) as IncidentLocation;


    if (this.sublocationRequired === true && this.incidentSublocation == null) {
      incidentReport.incidentSublocation = JSON.parse('{ "sublocationId": 0, "locationIdid": 0, "sortOrder": 1, "name":  "Not submitted" }') as IncidentSublocation;
    } else if (this.sublocationRequired === true) {
      incidentReport.incidentSublocation = JSON.parse(this.incidentSublocation) as IncidentSublocation;
    }


    incidentReport.incidentDescription = 'Web submission : ' + this.incidentDescription;

    incidentReport.reportingEmail = this.reportingEmail;
    this.storage.set('airport_reporting_email', this.reportingEmail);  // save the email address to local storage so we can re-use it for them

    // incidentReport.pictureData = this.cameraService.pictureData;
    incidentReport.desktopFileUpload = this.pictureName;

    // incidentReport.deviceId = this.device.uuid + " : " + this.device.serial + " : " + this.device.platform + " : " + this.device.version + " : " + this.device.manufacturer + " : " + this.device.model;

    this.http.post(action, incidentReport, { headers: { 'Content-Type': 'application/json' } } ).
      subscribe(
         success => { this.incidentReportResult(success as BaseResult, loader); },
         error => { this.handleError(error, incidentReport, loader); });
  }



  private incidentReportResult(resp: BaseResult, loader: Toast): void {
      const result = resp;
      console.log('result.Status: ' + result.Status);
      console.log('loginResult: ' + JSON.stringify(result));

      this.alertController.clear(loader.toastId, loader.toastContainerId);

      console.log('result.Status: ' + result.Status);
      if (result.Status === 0) {

        // reset fields so the user can enter another incident report
        this.resetIncidentReport();

        const toast: Toast = {
            type: 'success',
            title: 'Report submitted',
            body: result.Message,
            showCloseButton: false,
            closeHtml: ''
        };

        const alert = this.alertController.pop( toast );
        // let alert = this.alertController.pop({ title: "Report submitted", subTitle: result.Message, buttons: ['OK'], cssClass: "errorAlert" });
        // alert.present();
      } else {
        this.incidentReportError(result);
      }
  }

  private resetIncidentReport(): void {
        console.log('resetIncidentReport() called');
        this.incidentType = null;
        this.incidentLocation = null;
        this.incidentSublocation = null;
        this.sublocationRequired = false;
        this.incidentDescription = null;
        this.thumbnailLocation = this.airportws.serverName + '/img/SingleTransparentPixel.png';
        this.incidentDate = new Date();
  }


  private handleError(error: Response | any, incidentReport: Incident, loader: Toast) {
    console.log(`Error attempting to submit incident report: ` + JSON.stringify(incidentReport));
    console.log(`Error was: ` + JSON.stringify(error));

    this.alertController.clear(loader.toastId, loader.toastContainerId);

    const toast: Toast = {
        type: 'error',
        title: 'Report failed',
        body: 'Please try again',
        showCloseButton: true,
        closeHtml: '<button>Close</button>'
    };

    const alert = this.alertController.pop( toast );
//    let alert = this.alertController.create({ title: "Report failed", subTitle: error.Message, message: "Please try again", buttons: ['OK'], cssClass: "errorAlert" });
//    alert.present();
  }

  private incidentReportError(result: BaseResult) {

    const toast: Toast = {
        type: 'error',
        title: 'Report failed',
        body: 'Please try again',
        showCloseButton: true,
        closeHtml: '<button>Close</button>'
    };

    const alert = this.alertController.pop( toast );
//    let alert = this.alertController.create({ title: "Report failed", subTitle: result.Message, message: "Please try again", buttons: ['OK'], cssClass: "errorAlert" });
//    alert.present();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SmsPage');
  }

  public handleFileUploadResult(jsonResult: BaseResult) {

    if (jsonResult.Status === 0) {
        console.log('setting Thumbnail location with: ' + this.airportws.serverName + '/imageuploads/' + jsonResult.Value.substring(jsonResult.Value.indexOf('attachment')));
        this.setThumbnailLocation(this.airportws.serverName + '/imageuploads/' + jsonResult.Value.substring(jsonResult.Value.indexOf('attachment')));
        this.pictureName = jsonResult.Value;
    } else {
      const alert = this.alertController.pop( 'error', 'Picture upload failed', jsonResult.Message);
  //        let alert = this.alertController.create({ title: "Picture upload failed", subTitle: jsonResult.Message, buttons: ['OK'], cssClass: "errorAlert" });
  //        alert.present();
    }
  }

  public setThumbnailLocation(location: string) {
      console.log(`thumbnail location: ${location}`);
      this.thumbnailLocation = location;
  }

}
